import { SkeletonPage } from "@/components/SkeletonLoaders";
import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";

const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<SkeletonPage />}>
    <Component {...props} />
  </Suspense>
);

const SalonProviderListPage = Loadable(
  lazy(() => import("./pages/SalonProviderListPage"))
);
const SalonServicesListPage = Loadable(
  lazy(() => import("./pages/SalonServicesListPage"))
);
const SalonSlotsSelection = Loadable(
  lazy(() => import("./pages/SalonSlotsSelection"))
);
const SalonSummaryPage = Loadable(
  lazy(() => import("./pages/SalonSummaryPage"))
);
const SalonThanksPage = Loadable(lazy(() => import("./pages/SalonThanksPage")));



const salonRoutes = [
  {
    path: "salon",
    children: [
      {
        index: true,
        element: <Navigate to="1" replace />,
      },
      {
        path: ":category_id",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SalonProviderListPage />
          </Suspense>
        ),
      },
      {
        path: "services/:provider_id",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SalonServicesListPage />
          </Suspense>
        ),
      },
      {
        path: "slots-selection",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SalonSlotsSelection />
          </Suspense>
        ),
      },
      {
        path: "booking-summary",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SalonSummaryPage />
          </Suspense>
        ),
      },
      {
        path: "thanks",
        element: (
          <Suspense fallback={<SkeletonPage />}>
            <SalonThanksPage />
          </Suspense>
        ),
      },
    ],
  },
];

export default salonRoutes;
